<template>
  <div id="app">
    <Scene />
  </div>
</template>

<script>
import Scene from "./components/Scene.vue";

export default {
  name: "App",
  components: {
    Scene,
  },
};
</script>

<style lang="scss">
// css variables
:root {
  --dark-blue: #3966aa;
  --pink: #c73069;
  --yellow: #f8b917;
  --purple: #804875;
  --sky-blue: #48728c;
}

@font-face {
  font-family: "FS Elliot Pro";
  // src: url("~@/assets/fonts/FS Elliot Pro-Regular.otf");
  src: url("~@/assets/fonts/FS Elliot Pro-Regular.otf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "FS Elliot Light";
  // src: url("~@/assets/fonts/FS Elliot Pro-Light.otf");
  // src: url("~@/assets/fonts/FS Elliot Pro-Light.otf");
  src: url("~@/assets/fonts/FS Elliot Pro-Light.otf");

  font-weight: normal;
  font-style: normal;
}
.light {
  font-family: FS Elliot Light;
}
@font-face {
  font-family: "FS Elliot Heavy";
  src: url("~@/assets/fonts/FS Elliot Pro-Heavy.otf");
  font-weight: normal;
  font-style: normal;
}
.heavy {
  font-family: FS Elliot Heavy;
}
#app {
  font-family: FS Elliot Pro;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // margin-top: 60px;
}
p,
h1,
h2,
h3,
h4 {
  margin: 0;
  padding: 0;
}
body {
  font-family: FS Elliot Pro !important;
  margin: 0;
}
.btn {
  cursor: pointer;
}
.nipple {
  opacity: 1 !important;
  .back {
    display: none !important;
  }
  .front {
    background: unset !important;
    background-image: url(/joystick.png) !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    opacity: 1 !important;
    width: 76px !important;
    height: 76px !important;
    margin-left: -38px !important;
    margin-top: -38px !important;
  }
}
// .joysticks {
//   position: absolute;
//   bottom: 0;
//   right: 0;
//   background-color: red;
//   width: 200px;
//   height: 200px;
//   z-index: 5;
// }

.outer-ui {
  z-index: 6;
  position: absolute;
  top: 20px;
  right: 50px;
  width: 85px;
  background: none;
  border: none;
  @media only screen and (max-width: 600px) {
    right: 30px;
    img {
      width: 60px;
      height: 60px;
    }
  }
  & img {
    width: 90px;
  }
  &:hover {
    opacity: 0.6;
  }
  &:focus {
    outline: -webkit-focus-ring-color auto 0px;
  }
}
.btns-bottom {
  z-index: 6;
  position: absolute;
  right: 0;
  bottom: 7px;
  right: 30px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  padding: 0;
}

.bottom-control {
  cursor: pointer;
  width: 72px;
  height: 72px;
  margin-left: 10px !important;
  border-radius: 50%;
  box-shadow: 0px 5px 10px rgba(128, 128, 128, 0.555);
  background-color: white;
  border: 4px solid #233a88;
  background-repeat: no-repeat;
  background-position: center;
  &.music-btn {
    background-size: 40px;
    margin: 0;
    padding: 0;
    &.off {
      background-image: url("/icons/off.svg"), url("/icons/on.svg");
    }
    &.on {
      background-image: url("/icons/on.svg");
    }
  }
  &.screen-size {
    background-size: 50px;
    &.screen-full {
      background-image: url("/icons/screen-full.svg");
    }
    &.screen-mini {
      background-image: url("/icons/screen-mini.svg");
    }
  }
  &.instruct-open {
    background-size: 37px;
    background-image: url("/icons/nav-icon.svg");
  }
  &:hover {
    // opacity: 0.9;
    border: 3px solid #233a88;
  }
  &:focus {
    outline: none;
  }
}
.mobile {
  .btns-bottom {
    right: 15px;
    bottom: 15px;
  }
  .bottom-control {
    width: 50px;
    height: 50px;
    &.music-btn {
      background-size: 22px;
    }
  }
}
.phone-details {
  .outer-ui {
    right: 29%;
    @media only screen and (max-width: 2080px) {
      right: 24%;
    }
    @media only screen and (max-width: 1900px) {
      right: 19%;
    }
    @media only screen and (max-width: 1600px) {
      right: 17%;
    }
    @media only screen and (max-width: 1400px) {
      right: 10%;
    }
    @media only screen and (max-width: 1200px) {
      right: 5%;
    }
    // @media only screen and (max-width: 1400px) {
    //   right: 17%;
    // }
    // @media only screen and (max-width: 1200px) {
    //   right: 14%;
    // }
    // @media only screen and (max-width: 1000px) {
    //   right: 10%;
    // }
    // @media only screen and (max-width: 2080px) {
    //   right: 27%;
    // }
  }
  .plan-details-mobile {
    .outer-ui {
      // right: 0 !important;
    }
  }
}

.loader {
  color: #ffffff;
  font-size: 10px;
  // margin: 100px auto;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load4 1.3s infinite linear;
  animation: load4 1.3s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
@-webkit-keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em,
      0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em,
      0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0,
      0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em,
      0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em,
      0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em,
      0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em,
      0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em,
      0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
@keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em,
      0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em,
      0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0,
      0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em,
      0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em,
      0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em,
      0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em,
      0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em,
      0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
</style>
